import CharCount from "../components/tools/CharCount";

export function CharCountPage() {
  return <CharCount />;
}
